<template>
  <div class="warp">
    <el-tabs v-model="activeNameTabs">
      <el-tab-pane label="省级名师" name="one">
        <TabList :props-obj="propsObj" />
      </el-tab-pane>
      <el-tab-pane label="市级名师" name="two">
        <TabList />
      </el-tab-pane>
      <el-tab-pane label="区域名师" name="three">
        <TabList />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import TabList from './tabList';
export default {
  name: 'FamousTeaSpecialarea',
  components: {
    TabList
  },
  props: {
    propsId: {
      default: String,
      type: String
    }
  },
  data: () => {
    return {
      activeNameTabs: 'one',
      propsObj: {
        link: 'moduleDetail'
      }
    };
  },
  watch: {
    propsId: {
      handler: function(val) {
        this.propsObj.propsId = val;
      },
      immediate: true
    }
  },
  methods: {
  }
};
</script>
